module.exports = __webpack_public_path__ + "img/logo-shopeepay_qris-active.d2e74376.svg";